import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#1976d2',
      },
    },
});

class AppBarBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { counter: 0 };
    }
    componentDidMount = () =>{
        console.log("AppBarBox - componentDidMount()");
    }
    menuButtonCreate =(menuword,path)=>{
        let noclick = false;
        if(menuword === this.props.menuWord){
            noclick = true;
        }
        return (
            <Button color="inherit" component={Link} to={path} disabled={noclick}>{menuword}</Button>
        );
    }
    render() {
        return (
            <Box sx={{ flexGrow: 1 }}>
                <ThemeProvider theme={darkTheme}>
                    <AppBar position="static" color="primary">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            component={Link} to="/"
                            >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {this.menuButtonCreate("info","../info")}
                            {this.menuButtonCreate("app","../app")}
                            {this.menuButtonCreate("contact","../contact")}
                        </Typography>
                        {/*<Button color="inherit" component={Link} to="/">Top</Button>*/}
                    </Toolbar>
                    </AppBar>
                </ThemeProvider>
                <div style={{paddingLeft:15, paddingTop:20}}>
                    {this.props.children}
                </div>
            </Box>
        );
    }

}

export default AppBarBox;